import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export type PillTone =
  | "neutral"
  | "green"
  | "hay"
  | "sunny"
  | "purple"
  | "navy";

const TONE: Record<PillTone, string> = {
  neutral: "bg-[#F1F4EF] text-navy",
  green: "bg-[#DCF1E4] text-forest",
  hay: "bg-hay text-[#7A5A00]",
  sunny: "bg-[#FFEAB0] text-[#7A5A00]",
  purple: "bg-[#EAE6FE] text-[#5240B8]",
  navy: "bg-navy text-white",
};

type Props = HTMLAttributes<HTMLSpanElement> & {
  /** Visual tone. Default `neutral`. */
  tone?: PillTone;
  /** Back-compat: when `active`, renders the navy/dark variant (filter chip "selected"). */
  active?: boolean;
};

export function Pill({
  tone = "neutral",
  active,
  className,
  ...p
}: Props) {
  const cls = active ? TONE.navy : TONE[tone];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold leading-none",
        cls,
        className,
      )}
      {...p}
    />
  );
}
